<template>
  <div class="d-flex align-items-center border rounded">
    <div class="d-flex align-items-center justify-content-between mw-300px px-5">
      <div>
        <div v-if="partner">
          <div class="cursor-pointer fw-bolder">
            {{ partner.name }}
          </div>
        </div>
        <span v-else class="fw-bolder">
        {{ value }}
      </span>
      </div>

    </div>
    <div v-if="!isLoading" class="cursor-pointer py-2 px-4  bg-hover-light-primary" @click.stop="load">
      <i class="fad fa-sync"></i>
    </div>
    <div class="cursor-pointer py-2 px-4  bg-hover-light-primary" v-else>
      <i class="fad fa-sync"></i>
    </div>
  </div>
</template>

<script lang="ts">
import Partner from '@/entity/Partner';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  components: {}
})
export default class PartnerView extends Vue {
  isLoading = true
  @Prop({default: null}) readonly value!: string

  partner: Partner | null = null

  beforeMount() {

  }

  async mounted() {

  }

  async loadPartner() {

  }

  async load() {
    this.isLoading = true
  }
}
</script>
